<template>
  <div>
    <!-- Pass the transformed `result` to the MigrationMap component -->
    <MigrationMap :result="processedResult" :type="props.type" />
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import MigrationMap from "./MigrationMap.vue";

// Define props
const props = defineProps({
  result: Object,
  type: String,
});

// Transform the migration paths dynamically using a computed property
const processedResult = computed(() => {
  if (!props.result) return null; // Handle null/undefined props.result
  const resultCopy = { ...props.result }; // Shallow copy to avoid mutating props

  if (resultCopy.migrationPaths) {
    resultCopy.migrationPaths = resultCopy.migrationPaths.map(({ migrationPath, ...properties }) => ({
      migrationPath: JSON.parse(migrationPath), // Parse the JSON migrationPath
      ...properties,
    }));
  }

  return resultCopy; // Return the processed result
});
</script>